import { useContext } from 'react';
import { FrStateContext, FrState } from './fr-state-context';

export function useFrState(): FrState {
    const value = useContext(FrStateContext);
    if (!value) {
        throw new Error('Unexpectedly did not find FR state context');
    }
    return value;
}
